var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Utils
import { css } from 'styled-components';
// Styles
import { getTextOverflowStyles } from './getTextOverflowStyles';
export var getTypographyStyles = function (truncateText, theme) {
    var _a;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  cursor: inherit;\n  display: inherit;\n\n  ", "\n"], ["\n  font-family: ", ";\n  cursor: inherit;\n  display: inherit;\n\n  ", "\n"])), (_a = theme.typography) === null || _a === void 0 ? void 0 : _a.fontFamily, truncateText && getTextOverflowStyles());
};
var templateObject_1;
//# sourceMappingURL=getTypographyStyles.js.map